<template>
  <div class="jifen-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="推荐人手机号/姓名">
          <el-input v-model="filterForm.keyword" placeholder="请输入手机号或姓名" clearable style="width: 200px;" />
        </el-form-item>
        <el-form-item label="发放状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable style="width: 130px;">
            <el-option label="未发放" :value="0" />
            <el-option label="已发放" :value="1" />
            <el-option label="不发放" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="recordList"
        height="56vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column label="推荐人(上级)" min-width="160">
          <template slot-scope="scope">
            <div>{{ scope.row.crm_user }}</div>
            <div style="color: #999; font-size: 12px;">ID: {{ scope.row.crm_id }}</div>
          </template>
        </el-table-column>
        <el-table-column label="被推荐人(下级)" min-width="160">
          <template slot-scope="scope">
            <div>{{ scope.row.referee_user }}</div>
            <div style="color: #999; font-size: 12px;">ID: {{ scope.row.referee_crm_id }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="invite_code" label="邀请码" width="110" align="center" />
        <el-table-column prop="sh_id" label="绑定店铺" width="90" align="center" />
        <el-table-column prop="level" label="层级" width="70" align="center" />
        <el-table-column label="累计消费" width="110" align="center">
          <template slot-scope="scope">
            <span class="money">{{ parseFloat(scope.row.consume_money).toFixed(2) }}积分</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_num" label="订单数" width="80" align="center" />
        <el-table-column prop="last_order_time" label="最近下单" width="160" />
        <el-table-column label="获客奖励" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.reg_points }} 分</span>
          </template>
        </el-table-column>
        <el-table-column label="发放状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="statusTagType(scope.row.reg_status)">
              {{ statusText(scope.row.reg_status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openTreeDialog(scope.row)">查看下级</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 下级列表弹窗 -->
    <el-dialog
      :title="'会员 ' + (currentReferrer && currentReferrer.crm_user) + ' 的直接下级'"
      :visible.sync="treeDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-table
        v-loading="treeLoading"
        :data="treeList"
        border
        stripe
        height="400"
      >
        <el-table-column prop="referee_crm_id" label="下级会员ID" width="120" align="center" />
        <el-table-column prop="referee_user" label="下级手机号" width="150" align="center" />
        <el-table-column label="累计消费" width="120" align="center">
          <template slot-scope="scope">
            <span class="money">¥{{ parseFloat(scope.row.consume_money).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_num" label="订单数" width="100" align="center" />
        <el-table-column prop="level" label="层级" width="80" align="center" />
      </el-table>
      <div v-if="!treeLoading && treeList.length === 0" style="text-align: center; padding: 20px; color: #999;">
        暂无下级数据
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="treeDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { referralRecords, referralTree } from '@/api/jifen'

export default {
  name: 'JifenReferralRecords',
  data () {
    return {
      loading: false,
      recordList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filterForm: {
        keyword: '',
        status: ''
      },
      // 下级树弹窗
      treeDialogVisible: false,
      treeLoading: false,
      treeList: [],
      currentReferrer: null
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    statusText (status) {
      const map = { 0: '未发放', 1: '已发放', 2: '不发放' }
      return map[parseInt(status)] || '—'
    },

    statusTagType (status) {
      const map = { 0: 'warning', 1: 'success', 2: 'info' }
      return map[parseInt(status)] || 'info'
    },

    async fetchList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.keyword) params.keyword = this.filterForm.keyword
        if (this.filterForm.status !== '' && this.filterForm.status !== null) params.status = this.filterForm.status
        const res = await referralRecords(params)
        if (res && res.code === '0') {
          this.recordList = res.data || []
          this.total = res.total || 0
        } else {
          this.recordList = []
          this.total = 0
          this.$message.error(res && res.msg ? res.msg : '获取推荐记录失败')
        }
      } catch (error) {
        console.error('获取推荐记录失败', error)
        this.recordList = []
        this.total = 0
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.fetchList()
    },

    handleReset () {
      this.filterForm = { keyword: '', status: '' }
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchList()
    },

    async openTreeDialog (row) {
      this.currentReferrer = row
      this.treeDialogVisible = true
      this.treeLoading = true
      this.treeList = []
      try {
        const res = await referralTree({ crm_id: row.crm_id })
        if (res && res.code === '0') {
          this.treeList = res.data || []
        } else {
          this.treeList = []
          this.$message.error(res && res.msg ? res.msg : '获取下级列表失败')
        }
      } catch (error) {
        console.error('获取下级列表失败', error)
        this.treeList = []
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.treeLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jifen-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  .money {
    color: #ee530c;
  }
}
</style>
